import axios from "axios";
import { Agent } from "https";

const instance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  // baseURL: 'http://localhost:8080/v1/',
  //
  // // If the server has an invalid SSL cert
  // httpsAgent: new Agent({
  //   rejectUnauthorized: false
  // })
  //
  // // If the server doesn't handle CORS very well
  // headers: {
  //   'Access-Control-Allow-Origin': 'http://localhost:8080/',
  //   'Access-Control-Request-Method': '*',
  //   'Access-Control-Allow-Credentials': 'true',
  //   'Access-Control-Expose-Headers': 'Link'
  // }
  validateStatus: (status) => true,
  timeout: 30 * 1000 * 60,
});

// instance.defaults.timeout = 1800000;

export default instance;
